<template>
  <div id="login" class="member-wrap">
    <!-- 페이지 소개 -->
    <div class="noti">
      <div class="list-title">회원가입</div>
      <div class="detail">
        회원가입 후 플라이빗의 다양한 서비스를 이용하세요.
      </div>
    </div>

    <!-- 이메일 -->
    <div class="email">
      <div class="title">
        이메일<span class="red-text">(중복확인 필수)</span>
      </div>
      <div flex fjb>
        <div class="input-email">
          <el-input
            type="email"
            v-model="email"
            @focus="focusInput"
            clear
            placeholder="이메일 주소 입력"
            class="text-style"
            :class="{ checked: wrongEmail }"
            clearable
          />
        </div>
        <button @click="checkJoinedEmail" class="check-joined">
          중복확인
        </button>
      </div>
    </div>
    <div class="text-style-wrong" v-if="wrongEmail">
      올바른 이메일 주소를 입력해주세요.
    </div>
    <div class="text-style-wrong right" v-if="!wrongEmail && rightEmail">
      사용 가능한 이메일 입니다.
    </div>
    <div class="text-style-wrong" v-if="alreadyJoinedEmail">
      이미 가입된 이메일입니다.
    </div>

    <!-- 비밀번호 -->
    <div class="password">
      <div class="title">비밀번호</div>
      <el-input
        v-model="password"
        :disabled="disabledInput"
        placeholder="8~20자, 영문(대/소문자), 숫자, 특수문자 조합 필수"
        class="text-style"
        @input="validPassword"
        show-password
      />
    </div>

    <!-- 비밀번호 확인 -->
    <div class="checklist">
      <div class="list" :class="{ checked: check.English }">
        영문 대/소문자 포함
      </div>
      <div class="list" :class="{ checked: check.Number }">숫자포함</div>
      <div class="list" :class="{ checked: check.Length }">8자 이상</div>
      <div class="list mb4" :class="{ checked: check.SpecialCharacter }">
        특수문자 포함
      </div>
      <div class="specialCharacter-box">
        <p>
          {{ `. , ‘ / ~ ! @ # $ % ^ & * ( ) - _ = + [ ] { }| ; : < > / ? ` }}
        </p>
      </div>
    </div>
    <div class="check-password">
      <div class="title">비밀번호 확인</div>
      <el-input
        v-model="checkPassword"
        :disabled="disabledInput"
        placeholder="비밀번호 확인"
        class="text-style"
        :class="{ checked: wrongPassword }"
        show-password
      />
    </div>
    <div class="text-style-wrong" v-if="wrongPassword">
      비밀번호가 일치하지 않습니다.
    </div>

    <!-- 추천인 코드 -->
    <div class="code">
      <div class="title">추천인 UID(선택)</div>
      <el-input
        v-model="uuidx"
        placeholder="추천인 UID 입력"
        class="text-style"
      />
    </div>

    <!-- 약관 동의 -->
    <div class="agreebox">
      <div class="agree-area">
        <div class="terms-wrap" flex fjb fic>
          <el-checkbox v-model="agree.All" @change="checkAll"> </el-checkbox>
          <div class="terms-contents">
            <div class="left full">
              {{ $t("signup.allAgree") }}
              <div class="right"></div>
            </div>
          </div>
        </div>
        <div class="terms-wrap" flex fjb fic>
          <el-checkbox v-model="agree.age" @change="checkChange"> </el-checkbox>
          <div class="terms-contents">
            <div class="left full" flex fic>
              {{ `만 19세 이상입니다.`
              }}<span class="red-text">({{ $t("signup.mandatory") }})</span>
            </div>
            <div class="right"></div>
          </div>
        </div>
        <div class="terms-wrap" flex fjb fic>
          <el-checkbox v-model="agree.service" @change="checkChange">
          </el-checkbox>
          <div class="terms-contents">
            <p class="left">
              {{ $t("signup.agreeTermsOfServices")
              }}<span class="red-text">({{ $t("signup.mandatory") }})</span>
            </p>
            <div class="right">
              <button @click="ServicePopup" class="white">
                <p>{{ $t("signup.seeContent") }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="terms-wrap" flex fjb fic>
          <el-checkbox v-model="agree.private" @change="checkChange">
          </el-checkbox>
          <div class="terms-contents">
            <div class="left" flex fic>
              {{ $t("signup.agreePersonalInformationCollection")
              }}<span class="red-text">({{ $t("signup.mandatory") }})</span>
            </div>
            <div class="right">
              <button @click="PrivatePopup" class="white">
                <p>{{ $t("signup.seeContent") }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="terms-wrap" flex fjb fic>
          <el-checkbox v-model="agree.personal" @change="checkChange">
          </el-checkbox>
          <div class="terms-contents">
            <div class="left" flex fic>
              {{ $t("signup.agreePersonalInformationCollection") }}({{
                $t("signup.optional")
              }})
            </div>
            <div class="right">
              <button @click="PrivatePopup" class="white">
                <p>{{ $t("signup.seeContent") }}</p>
              </button>
            </div>
          </div>
        </div>
        <div class="terms-wrap" flex fjb fic>
          <el-checkbox v-model="agree.promotion" @change="checkChange">
          </el-checkbox>
          <div class="terms-contents">
            <div class="left">
              {{ $t("signup.agreePromotionAndMarketing") }}({{
                $t("signup.optional")
              }})
            </div>
            <div class="right">
              <button @click="Marketing" class="white">
                <p>{{ $t("signup.seeContent") }}</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 알리슬라이드 -->
    <div class="allislide-wrap">
      <allibaba
        @send-response-data-event="getResponseData"
        ref="alibaba"
        :swapvisible="swapVisible"
      ></allibaba>
    </div>

    <!-- 이메일 인증 버튼 -->
    <vs-button
      color="danger"
      class="btn-block custom"
      type="filled"
      :disabled="activeButton"
      @click="submit"
      >{{ $t("signup.emailVerify") }}</vs-button
    >

    <!-- 미성년 서비스 이용제한 안내 -->
    <Popup
      :isShow="ageModal.isShow"
      :closePopup="closePopup"
      :popData="{
        title: '미성년자 서비스 이용제한 안내',
        confirm: '확인',
      }"
    >
      <div slot="content" class="popup-content">
        <p class="keycolor mb20">{{ ageModal.contents[0] }}</p>
        <p class="fw500 mb20">{{ ageModal.contents[1] }}</p>
        <p class="mb0">{{ ageModal.contents[2] }}</p>
      </div>
    </Popup>

    <!-- 인증 메일 발송 완료 안내 -->
    <Popup
      :isShow="complete.isShow"
      :closePopup="closeCompleteModal"
      :popData="{
        title: '인증 메일 발송 완료',
        confirm: '확인',
      }"
    >
      <div slot="content" class="popup-content">
        <p class="keycolor mb20">
          {{ "회원님의 계정으로 인증 이메일 발송하였습니다." }}
        </p>
        <p class="fw500 mb0">
          {{
            "※2시간 이내에 이메일 인증을 완료하지 못한 경우, 회원가입 절차를 처음부터 다시 진행해야 합니다."
          }}
        </p>
      </div>
    </Popup>

    <!-- 추천인(UID) 선택 안내 -->
    <Popup
      :isShow="uuidxGuideModal.isShow"
      :closePopup="closeUuidxGuideModal"
      :popData="{
        title: '추천인 UID(선택) 동의 안내',
        confirm: '확인',
      }"
    >
      <div slot="content" class="popup-content">
        <p class="mb0" v-html="uuidxGuideModal.contents"></p>
      </div>
    </Popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import Api from "@/common/Api";
import allibaba from "../login/allibaba";
import Popup from "@/components/common/Popup.vue";

export default {
  components: {
    allibaba,
    Popup,
  },
  created() {
    // this.RestrictedService();
    if (this.$route.query.event) {
      sessionStorage.setItem("event", this.$route.query.event);
    }
  },
  data() {
    return {
      // test 용
      // email: "asdgf@fff.sss",
      // password: "qwer1234!",
      // checkPassword: "qwer1234!",
      // uuidx: "aaa",

      // 실제 data
      email: "",
      password: "",
      checkPassword: "",
      uuidx: this.$route.query.invite || "",
      rcapt_sig_key: this.$isDevServer
        ? "6LeiYOAUAAAAADdnn73t4Qwg6jZNhRAA-JGRpzXS"
        : "6LfOpkcUAAAAAG4JscMvBbFfTpRHbPaUJQcE4WYE",

      rcapt_id: null,
      ali_response: null,
      recaptchaErr: false,
      swapVisible: false,
      ageModalContent: true,
      ageModal: {
        isShow: true,
        contents: [
          "미성년자(만 19세 미만) 회원은 입/출금(KRW, 가상자산) 및 거래(가상자산 매수, 매도) 서비스를 포함한 Flybit 에서 제공하는 주요 서비스의 이용이 제한됩니다.",
          "Flybit 은 투자자의 보호와 거래투명성 확보를 위하여 노력합니다.",
          "전문성이 없는 일반인 등이 가격 변동폭이 큰 가상자산 투자에 참여하여 손실을 입는 것을 방지하는 한편, 가상자산 거래소가 투기의 장으로 변질되는 것을 미연에 대응함으로 안전하고 원활한 서비스를 제공 하겠습니다.",
        ],
      },
      // rightEmail: true, // test 용. 가입 가능한 이메일 노출 문구
      rightEmail: false, // 실제 data. 가입 가능한 이메일 노출 문구
      wrongEmail: false, //이메일 오입력 시 안내 문구
      wrongPassword: false, //비밀번호 오입력 시 안내 문구
      disabledInput: true,
      alreadyJoinedEmail: false,
      check: {
        //비밀번호 각 항목 별 체크
        // test 용
        // English: true,
        // Number: true,
        // Length: true,
        // SpecialCharacter: true,

        // 실제 data
        English: false,
        Number: false,
        Length: false,
        SpecialCharacter: false,
      },
      agree: {
        All: false,
        age: false,
        service: false,
        private: false,
        personal: false,
        promotion: false,
      },
      complete: {
        isShow: false,
      },
      uuidxGuideModal: {
        isShow: false,
        contents:
          "추천인 UID(선택)를 적용하시려면<br /><span style='text-decoration: underline;'>'개인정보 수집 및 이용 동의(선택)'</span><br />항목에 동의해 주세요.",
      },
    };
  },
  computed: {
    ...mapState("Firebase", ["zendeskUrl"]),
    //이메일 인증 버튼 활성화 조건
    activeButton() {
      if (
        this.email != this.rightEmail &&
        this.check.English == true &&
        this.check.Number == true &&
        this.check.Length == true &&
        this.check.SpecialCharacter == true &&
        this.wrongPassword == false &&
        this.agree.age &&
        this.agree.service &&
        this.agree.private &&
        this.ali_response != null
      ) {
        return false;
      } else {
        return true;
      }
    },
    disabled() {
      //추천인 아이디 disabled 함수
      if (this.$route.query.invite) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted() {
    if (this.rcapt_id) grecaptcha.reset(this.rcapt_id);
    if (this.$refs.alibaba) this.$refs.alibaba.aliSlideReset();
  },
  methods: {
    checkJoinedEmail() {
      if (this.email == "") {
        // 이메일 미입력 시
        this.alreadyJoinedEmail = false;
        this.rightEmail = false;
        this.disabledInput = true;
        this.wrongEmail = true;
      } else {
        //이메일 입력 시
        Api.User.checkValidEmail({ email: this.email })
          .then((res) => {
            if (res.body == "true") {
              //이메일 중복일 때
              this.alreadyJoinedEmail = true;
              this.rightEmail = false;
              this.password = "";
              this.checkPassword = "";
              this.disabledInput = true;
            } else {
              //이메일 중복 아닐 때
              if (this.wrongEmail == true) {
                //이메일 양식 틀렸을 때
                this.disabledInput = true;
              } else {
                //이메일 양식 맞을 때
                this.alreadyJoinedEmail = false;
                this.rightEmail = true;
                this.disabledInput = false;
              }
            }
          })
          .catch((e) => {});
      }
    },
    ServicePopup() {
      window.open(this.zendeskUrl["ko"]["term"]);
    },

    PrivatePopup() {
      window.open(this.zendeskUrl["ko"]["joinFication"]);
    },
    Marketing() {
      window.open(this.zendeskUrl["ko"]["marketing"]);
    },
    submit() {
      if (this.uuidx !== "" && !this.agree.personal) {
        this.uuidxGuideModal.isShow = true;
        this.ali_response = null;
        if (this.rcapt_id) grecaptcha.reset(this.rcapt_id);
        this.$refs.alibaba.aliSlideReset();
        return;
      }
      const g_recaptcha_response =
        this.rcapt_id !== null ? grecaptcha.getResponse(this.rcapt_id) : null;
      if (!g_recaptcha_response && !this.ali_response) {
        this.recaptchaErr = true;
        this.onSubmit = false;
        return false;
      }
      const { ali_token, ali_sig, ali_csessionid } = this.ali_response
        ? this.ali_response
        : {};

      const params = {
        email: this.email,
        password: this.password,
        agreePromotion: this.agree.promotion ? "Y" : "N",
        agreePersonal: this.agree.personal ? "Y" : "N",
        g_recaptcha_response,
        ali_token,
        ali_sig,
        ali_csessionid,
        uuidx: this.uuidx.replace(/ /g, ""),
      };

      Api.User.join(params)
        .then((_res) => {
          sessionStorage.removeItem("event");
          // this.SendEmailCompleted();
          this.email = "";
          this.password = "";
          this.checkPassword = "";
          this.uuidx = this.$route.query.invite || "";
          this.agree.All = false;
          this.agree.age = false;
          this.agree.service = false;
          this.agree.private = false;
          this.agree.personal = false;
          this.agree.promotion = false;
          this.complete.isShow = true;
        })
        .catch((e) => {
          this.ali_response = null;
          if (this.rcapt_id) grecaptcha.reset(this.rcapt_id);
          this.$refs.alibaba.aliSlideReset();
          if (e.code === "21000") {
            this.$vs.notify({
              title: "안내",
              text: "이미 가입된 이메일입니다.",
              position: "top-right",
              color: "danger",
            });
          } else if (e.code === "REF001") {
            this.$vs.notify({
              title: "안내",
              text:
                "유효하지 않은 추천인 코드 입니다. 추천인 코드를 다시 확인 해주세요.",
              position: "top-right",
              color: "danger",
            });
          } else {
            if (this.rcapt_id) grecaptcha.reset(this.rcapt_id);
            this.$refs.alibaba.aliSlideReset();
            this.joinFailNoti(e.msg);
          }
        });
    },
    joinFailNoti(text, title = this.$t("signup.title")) {
      this.$vs.notify({
        title,
        text,
        position: "top-right",
        color: "danger",
      });
    },

    checkAll() {
      // 약관동의 전체 동의 체크
      this.agree.age = this.agree.All;
      this.agree.service = this.agree.All;
      this.agree.private = this.agree.All;
      this.agree.personal = this.agree.All;
      this.agree.promotion = this.agree.All;
    },
    checkChange() {
      //약관동의 개별 선택 시 all checked
      if (
        this.agree.age &&
        this.agree.service &&
        this.agree.private &&
        this.agree.personal &&
        this.agree.promotion
      ) {
        this.agree.All = true;
      } else {
        this.agree.All = false;
      }
    },
    getResponseData(data) {
      // data = rcapt_id || ali_response
      if (!isNaN(data)) {
        this.rcapt_id = data;
        this.ali_response = null;
      } else {
        this.rcapt_id = null;
        this.ali_response = data;
      }
    },
    closePopup() {
      this.ageModal.isShow = !this.ageModal.isShow;
    },
    closeCompleteModal() {
      this.$router.push({ name: "Login" });
      this.complete.isShow = !this.complete.isShow;
    },
    closeUuidxGuideModal() {
      this.uuidxGuideModal.isShow = !this.uuidxGuideModal.isShow;
    },
    // 이메일 포커스인
    focusInput() {
      this.email = "";
      this.rightEmail = false;
      this.alreadyJoinedEmail = false;
      this.password = ""; //비밀번호 초기화
      this.checkPassword = ""; //비밀번호 확인 초기화
      this.disabledInput = true; //비밀번호, 비밀번호 초기화 disabled
    },
    validPassword() {
      // 비밀번호 체크
      const checkonlyEnglish = /[a-zA-Z]/g;
      const checkonlyNumber = /[0-9]/g;
      const checkonlyLength = /^.{8,}$/;
      const checkonlySpecialCharacter = /(\.|\,|\'|\~|\!|\@|\#|\$|\%|\^|\&|\*|\(|\)|\-|\_|\=|\+|\[|\]|\{|\}|\]|\||\;|\:|\<|\>|\/|\?)/g;

      this.check.English = checkonlyEnglish.test(this.password); //영문만 체크
      this.check.Number = checkonlyNumber.test(this.password); //숫자만 체크
      this.check.Length = checkonlyLength.test(this.password); //길이만 체크
      this.check.SpecialCharacter = checkonlySpecialCharacter.test(
        this.password
      ); //특수문자만 체크

      if (this.password != this.checkPassword) {
        if (this.checkPassword == "") {
          return (this.wrongPassword = false);
        }
        this.wrongPassword = true;
      } else {
        this.wrongPassword = false;
      }
      if (this.password == "") {
        //비밀번호 공란일 때
        this.check.English = false;
        this.check.Number = false;
        this.check.Length = false;
        this.check.SpecialCharacter = false;
      }
    },
  },

  watch: {
    email() {
      // 이메일 인풋키 체크
      const checkEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (checkEmail.test(this.email) || this.email == "") {
        this.wrongEmail = false;
      } else {
        this.wrongEmail = true;
      }
    },

    // 비밀번호 확인 체크
    checkPassword(e) {
      if (this.password != this.checkPassword) {
        this.wrongPassword = true;
      } else {
        this.wrongPassword = false;
      }
    },
  },

  name: "Member",
};
</script>

<style lang="scss" scoped>
body {
  p {
    margin-bottom: 0;
    font-size: 14px;
  }
}
.member-wrap {
  font-size: 14px;
  color: #333333;
  .noti {
    padding-bottom: 10px;
    .list-title {
      font-size: 16px;
      font-weight: 500;
      line-height: 1.43;
    }
    .detail {
      color: #666;
    }
  }
  .text-style-wrong {
    margin-top: 3px;
    color: #eb3246;
    &.right {
      color: #00b473;
    }
  }
  .title {
    margin-bottom: 8px;
    font-weight: 500;
  }
  .email,
  .password,
  .code,
  .agreebox {
    margin-top: 16px;
  }
  .email {
    .input-email {
      width: calc(100% - 100px);
    }
    .check-joined {
      width: 90px;
      border-radius: 4px;
      border: solid 1px #dcdfe3;
      line-height: 28px;
      color: #333;
      background-color: #fbfbfc;
    }
  }
  .red-text {
    color: #eb3246;
  }
  .checklist {
    padding: 10px;
    margin: 8px 0 16px;
    border: solid 1px #dcdfe3;
    border-radius: 2px;
    background-color: #f7f8fa;
    .list {
      position: relative;
      margin-bottom: 12px;
      padding-left: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      &:after {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        width: 14px;
        height: 14px;
        background-image: url("~@/assets/img/common/icon-check-disabled.svg");
        background-repeat: no-repeat;
      }
      &.checked {
        &:after {
          background-image: url("~@/assets/img/common/icon-check-abled.svg");
        }
      }
    }
    .specialCharacter-box {
      width: fit-content;
      /* height: 24px; */
      margin-left: 20px;
      padding: 0 10px;
      background-color: #dcdfe3;
      p {
        line-height: 24px;
      }
    }
  }
  .agreebox {
    .agree-area {
      font-size: 14px;
      .terms-wrap {
        margin-bottom: 16px;
        .terms-contents {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 30px);
          .left {
            width: calc(100% - 100px);
            word-break: break-all;
            &.full {
              width: 100%;
            }
          }
        }
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      .terms-list-wrap {
        .term-list {
          justify-content: space-between;
          .term-right {
            border-radius: 4px;
            border: solid 1px #dcdfe3;
            background-color: #ffffff;
          }
        }
      }
    }
  }
}
.allislide-wrap {
  margin-top: 19px;
}
.btn-block {
  margin-top: 16px;
}
</style>
